import { Button, ButtonGroup, Spinner } from "react-bootstrap";
import { RANGE_OPTIONS } from "../../constants/epicLeaderboard";
import type { RangeOption } from "../../constants/epicLeaderboard";
import "./playerRangeBar.css";

const SHORT_LABELS: Record<RangeOption, string> = {
  "7d": "7D",
  "30d": "30D",
  "90d": "90D",
  year: "YTD",
  all: "All"
};

type Props = {
  range: RangeOption;
  onChange: (range: RangeOption) => void;
  loading?: boolean;
};

// Page-level time control: sticks to the top while the page scrolls.
const PlayerRangeBar = ({ range, onChange, loading = false }: Props) => (
  <div className="player-range-bar">
    <ButtonGroup size="sm" aria-label="Date range">
      {RANGE_OPTIONS.map((option) => (
        <Button
          key={option.value}
          variant={option.value === range ? "info" : "outline-info"}
          aria-pressed={option.value === range}
          title={option.label}
          onClick={() => option.value !== range && onChange(option.value)}
        >
          {SHORT_LABELS[option.value]}
        </Button>
      ))}
    </ButtonGroup>
    <div className="player-range-status" aria-live="polite">
      {loading && (
        <Spinner animation="border" variant="light" size="sm" role="status">
          <span className="visually-hidden">Loading</span>
        </Spinner>
      )}
    </div>
  </div>
);

export default PlayerRangeBar;
